import { Droppable } from 'react-beautiful-dnd';
import { DRAG_AND_DROP_CONSTANTS } from 'utils/dndBoard/constants';

const Trashcan = () => {
	const fontSize = '100px';

	return (
		<Droppable droppableId={DRAG_AND_DROP_CONSTANTS.TRASHCAN} type={DRAG_AND_DROP_CONSTANTS.PAGE}>
			{(provided, snapshot) => {
				return (
					<div {...provided.droppableProps} ref={provided.innerRef} className='dnd-trashcan rounded mr-2 d-flex flex-column justify-content-center align-items-center'>
						<i className={`far fa-trash-alt ${snapshot.isDraggingOver && 'text-success'}`} style={{ fontSize }} />
						{provided.placeholder}
					</div>
				);
			}}
		</Droppable>
	);
};

export default Trashcan;
